export default __webpack_public_path__ + "static/media/logo-white.c2122339.png";